import { TReduxActions } from '../../types/redux';
import { IFormState } from '../../types/form';
import { EFormActionTypes } from '../../actions/form';

const defaultFormState: IFormState = {
  isLoading: false,
  isFileUploading: false,
  fileUploadingProgress: 0,
  isSubmitted: false,
  errors: {},
  inputsState: {
    fullName: '',
    email: '',
    phone: '',
    additionalContact: '',
    cvUrl: '',
    agreement: false,
    cvFile: undefined,
    referer: {
      fullName: '',
      email: '',
    },
  },
};

export function formReducer(state: IFormState = defaultFormState, { type, payload }: TReduxActions): IFormState {
  switch (type) {
    case EFormActionTypes.SetIsLoading:
      return <IFormState>{
        ...state,
        isLoading: payload,
      };

    case EFormActionTypes.SetIsFileUploading:
      return <IFormState>{
        ...state,
        isFileUploading: payload,
      };

    case EFormActionTypes.SetFileUploadingProgress:
      return {
        ...state,
        fileUploadingProgress: payload,
      };

    case EFormActionTypes.SetErrors:
      return {
        ...state,
        errors: payload,
      };

    case EFormActionTypes.SetIsSubmitted:
      return <IFormState>{
        ...state,
        isSubmitted: payload,
      };

    case EFormActionTypes.ResetForm:
      return defaultFormState;

    case EFormActionTypes.SetInputsState:
      return {
        ...state,
        inputsState: {
          ...state.inputsState,
          ...payload,
          referer: {
            ...state.inputsState.referer,
            ...payload.referer,
          },
        },
      };

    case EFormActionTypes.ResetFileState:
      return {
        ...state,
        inputsState: {
          ...state.inputsState,
          cvFile: defaultFormState.inputsState.cvFile,
        },
      };

    default:
      return state;
  }
}
